import React, { useState } from "react";
import isEmpty from "../../validation/is-empty";
import PropTypes from "prop-types";

import Table from "../table/Table";
import Modal from "../modal/Modal";
import PostContractCriticalSelection from "./PostContractCriticalSelection";

import { postContractTableAdaptor } from "./PostContractAdaptor.functions";
import { PostContractTableModal } from "./PostContractTableModal";

import "./PostContractTable.css";
import { pc2APIs } from "../../api/api-endpoints/PostContract2.0Endpoints";
import { translate } from "../../utils/translation";

PostContractTable.propTypes = {
  postContract: PropTypes.object,
  isTable: PropTypes.bool,
  isRegister: PropTypes.bool,
  pageSize: PropTypes.number,
  component: PropTypes.object,
  config: PropTypes.object,
  selectedReport: PropTypes.object,
  moduleId: PropTypes.string,
  tableName: PropTypes.string,
  isMenuAvailable: PropTypes.bool,
};

export default function PostContractTable(props) {
  const { postContract } = props;
  const { isTable, isRegister } = props;
  const { pageSize } = props;
  const { component, config } = props;
  const { selectedReport } = props;
  const { moduleId, tableName, isMenuAvailable } = props;

  const [selectedRow, setSelectedRow] = useState({});

  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);

  const { columns, rows } = postContractTableAdaptor(
    component,
    config,
    isRegister
  );

  if (isEmpty(columns)) {
    return null;
  }

  let style = "post-contract-table";
  if (isTable) {
    style = "";
  }

  return (
    <div className={style}>
      <Table
        title={component?.Heading}
        tableArray={rows}
        columns={columns}
        tableSize={pageSize || rows.length}
        isTitleDisabled={!isTable}
        isTotalDisabled={!isRegister}
        isFilterDisabled={!isRegister}
        isPaginationDisabled={!isTable}
        // Row Selection
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        // Modal Control
        tableName={tableName}
        setModal={setModal1}
        isMenuAvailable={isMenuAvailable}
        moduleId={moduleId}
      />
      <Modal
        // Modal Props
        title={component?.Heading}
        Component={PostContractTableModal}
        modal={modal1}
        setModal={setModal1}
        // Component Props
        columns={columns}
        selectedRow={selectedRow}
      />

      {component?.HasCriticalSelection && (
        <div>
          <Modal
            // Modal Props4
            title={translate("Select Critical")}
            Component={PostContractCriticalSelection}
            modal={modal2}
            setModal={setModal2}
            // Component Props
            setShow={setModal2}
            data={rows}
            columns={columns}
            label={"Select Critical"}
            postContract={postContract}
            postContractId={selectedReport.PostContractId}
            projectId={selectedReport.ProjectId}
            url={pc2APIs().save_critical_variations}
            sheetName={component.Heading}
          />
          <button
            className="general-upload-button"
            onClick={() => {
              setModal2(true);
            }}
          >
            {"Select Critical"}
          </button>
        </div>
      )}
    </div>
  );
}
